import SharedDialog from '@/global/Modal/Modal';

export type EnrichmentSavePreview = {
  searchType: string;
  analysisMethod: string;
  itemCount: number;
  source: string;
  geneFilterType?: string;
};

type SaveEnrichmentModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  name: string;
  setName: (value: string) => void;
  preview: EnrichmentSavePreview | null;
  isSaving: boolean;
};

const SaveEnrichmentModal = ({
  isOpen,
  onClose,
  onConfirm,
  name,
  setName,
  preview,
  isSaving,
}: SaveEnrichmentModalProps) => {
  return (
    <SharedDialog
      isOpen={isOpen}
      onClose={onClose}
      title="Save Enrichment"
      description="Save this enrichment analysis and its results to your profile so you can reopen them later."
      confirmText={isSaving ? 'Saving...' : 'Save Enrichment'}
      cancelText="Cancel"
      onConfirm={onConfirm}
      hasConfirmBtn
    >
      <div className="mt-4">
        <div className="mb-3">
          <label htmlFor="enrichmentSaveName" className="form-label font-medium">
            Name:
          </label>
          <input
            id="enrichmentSaveName"
            type="text"
            className="form-control"
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="Enter a name for this enrichment"
            maxLength={100}
            disabled={isSaving}
          />
          {!name.trim() && <small className="text-danger">Please enter a name</small>}
        </div>

        {preview && (
          <div className="mt-3">
            <h6 className="font-medium mb-2">Enrichment details:</h6>
            <div className="bg-light p-3 rounded text-sm">
              <div>
                <small className="text-muted">Type:</small>{' '}
                <strong>{preview.searchType === 'VARIANTS' ? 'Variants' : 'Genes'}</strong>
              </div>
              <div>
                <small className="text-muted">Method:</small> <strong>{preview.analysisMethod}</strong>
              </div>
              <div>
                <small className="text-muted">Identifiers:</small> <strong>{preview.itemCount}</strong>
              </div>
              <div>
                <small className="text-muted">Source:</small> <strong>{preview.source}</strong>
              </div>
              {preview.geneFilterType && (
                <div>
                  <small className="text-muted">Identifier type:</small>{' '}
                  <strong>{preview.geneFilterType}</strong>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </SharedDialog>
  );
};

export default SaveEnrichmentModal;
